<div
    class="entry"
>
    @if (title()) {
        <h3 class="entry__title">
            {{ title() }}
        </h3>
    }

    @if (value()) {
        <span class="entry__value">
            Ja
        </span>
    } @else if (value() === false) {
        <span class="entry__value">
            Nein
        </span>
    } @else {
        <span class="entry__value">
            Nicht bekannt
        </span>
    }
</div>
